import type { Faq } from '../types/product';

export const faqs: Faq[] = [
  {
    q: 'È utile se sto iniziando con i Fiori di Bach?',
    a: [
      'Sì. Può accompagnare lo studio e aiutarti a organizzare le informazioni. Il Tomo I presenta il percorso della consulenza; il Tomo II mostra esempi di confronto e personalizzazione.',
      'Per l’utilizzo professionale servono una preparazione adeguata e la conoscenza dei limiti del proprio ruolo. Il kit non conferisce qualifiche.',
    ],
  },
  {
    q: 'Include un elenco dei 38 rimedi con le parole chiave?',
    a: [
      'Sì. La Mappa Rapida comprende tutti i 38 rimedi, i sette gruppi tradizionali, descrizioni sintetiche, confronti e indice alfabetico.',
    ],
  },
  {
    q: 'Come ricevo il materiale?',
    a: [
      'Il prodotto viene fornito esclusivamente in formato digitale PDF. Le indicazioni per accedere ai materiali sono riportate nella conferma d’acquisto.',
      'Non viene spedito un prodotto cartaceo.',
    ],
  },
  {
    q: 'Devo stampare tutto?',
    a: [
      'No. Puoi consultare i PDF su computer, tablet o smartphone. Se preferisci la carta, puoi stampare l’intero kit o soltanto le schede che utilizzi più spesso.',
    ],
  },
  {
    q: 'Come posso chiedere assistenza o informazioni sui rimborsi?',
    a: [
      'Scrivi a soportelumenakasha@gmail.com. Puoi richiedere un rimborso entro 7 giorni di calendario dall’acquisto, seguendo la nostra Politica di rimborso. Le condizioni applicabili all’acquisto sono quelle presentate nel checkout.',
    ],
  },
  {
    q: 'Posso condividere il kit con altre persone?',
    a: [
      'L’acquisto è per uso personale. Puoi usare il materiale per lo studio e la preparazione del tuo lavoro. Non è consentito redistribuire, rivendere o pubblicare i PDF senza autorizzazione.',
    ],
  },
];
